import React from 'react';
import { Alert, Stack } from '@mui/material';
import { useAnnouncement } from '../context/AnnouncementContext';
import { useMaintenance } from '../context/MaintenanceContext';

export default function SystemNoticeBanner({ includeAnnouncement = true }) {
  const { announcement } = useAnnouncement();
  const { maintenanceMode, maintenanceMessage } = useMaintenance();
  if (!maintenanceMode && !(includeAnnouncement && announcement?.message)) return null;
  return <Stack spacing={1} sx={{ p: 1.5 }} aria-live="polite">
    {maintenanceMode && <Alert severity="warning">Maintenance mode is enabled. {maintenanceMessage || 'Some pages are temporarily unavailable. Incident Management remains available.'}</Alert>}
    {includeAnnouncement && announcement?.message && <Alert severity={announcement.type === 'urgent' || announcement.type === 'emergency' ? 'warning' : 'info'} sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{announcement.message}</Alert>}
  </Stack>;
}
